const url = '/component-levels';
const Provider = 'ComponentLevels';
const dbModel = 'ComponentLevels';

export { url, Provider, dbModel };
